import React from "react";
import { Link } from "react-router-dom";
export function BrandMark({
  className = ""
}: {
  className?: string;
}) {
  return <Link to="/" className={`group inline-flex shrink-0 items-center rounded-lg bg-transparent transition-transform focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-ivory ${className}`} aria-label="Agave Family home" data-id="element-61" data-mp="yhm7s23usykq">
      <img src="https://cdn.magicpatterns.com/uploads/6xvxXWGR6PhnV2LyYQmf5t/Agave-Family-Logo-Transparent.png" alt="Agave Family" className="h-[60px] w-auto object-contain transition-transform duration-300 group-hover:scale-[1.04]" data-id="element-62" data-mp="1m781wb5dcnlv" />
    </Link>;
}